import { PageLoader } from "../components/ui";
import { useSettingsDraft } from "../hooks/useSettingsDraft";
import { ShippingSettingsEditor } from "./settings/ShippingSettingsEditor";

export function Shipping() {
  const { draft, setValue, saveMut, showLoader } = useSettingsDraft({
    saveToast: "Shipping settings saved",
  });

  if (showLoader) return <PageLoader />;

  return (
    <div className="page-scroll space-y-5">
      <ShippingSettingsEditor draft={draft} setValue={setValue} saveMut={saveMut} />
    </div>
  );
}
